module.exports = __webpack_public_path__ + "media/assets/images/category/Birthday@2x-ed65c40fdb190a5c44199fb92b2d6bb6.png";